import React, {Component} from 'react';
import _ from 'lodash';

import {func, object} from 'prop-types';
import { updateStepIfDifferent } from '../../helpers/routes';

class Age extends Component {
  constructor (props) {
    super(props);
    this.state = {
      age: this.props.quiz.fieldValues.Age,
      animate: ''
    };

    this._nextStep = this._nextStep.bind(this);
  }

  componentDidMount () {
    const quote = this.props.quiz.fieldValues.Quote.charAt(0).toUpperCase() + this.props.quiz.fieldValues.Quote.slice(1);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'GAEvent',
      'eventCategory': 'View',
      'eventAction': 'Quiz',
      'eventLabel': quote + ' - Age',
      'eventValue': undefined
    });
    setTimeout(() => {
      this.setState({
        animate: 'fadeIn'
      });
    }, 600);
  }

  _validate (val = this.props.quiz.fieldValues.Age) {
    const isValid = (val >= 19 && val <= 122);
    if (!isValid) updateStepIfDifferent(this.props.quiz.step);
    return isValid;
  }

  _prevStep () {
    // this.setState({animate: 'fadeOut'});
    setTimeout(() => {
      window.history.go(-1);
    }, 600);
  }

  _handleAgeChange (age) {
    if (age.length <= 3) {
      this.props.reducer(age);
    }
  }

  _nextStep () {
    const {quiz, stepMethods} = _.clone(this.props);
    let nextStep = quiz.step + 1;
    const intAge = parseInt(quiz.fieldValues.Age, 10);

    if (stepMethods.isNextStep()) {
      if (intAge < 64) {
        nextStep++; // jump past Medicare selection, into Household
      } else if (intAge > 64) {
        this.props.setFieldValue('Medicare', true);
        nextStep += 3; // jump past Medicare selection, straight to Budget
      }

      stepMethods.setStep(nextStep);
    }
  }

  static getDerivedStateFromProps (props, state) {
    const { quiz } = _.clone(props);
    let fieldValues = quiz.fieldValues;

    if (fieldValues.Age && state.age !== fieldValues.Age) {
      if (fieldValues.Age >= 65 && quiz.location.loc.Medicare === true) {
        props.updateQuote('medicare');

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'visitorType': 'Prospect - Medicare'
        });
      } else {
        props.updateQuote('individuals');
      }
      return {
        'age': fieldValues.Age
      };
    }
    return null;
  }

  render () {
    const p = _.clone(this.props);
    const { quiz } = p;
    const ageVal = p.quiz.fieldValues.Age;
    let isEnabled = this._validate(ageVal);
    let notice;

    if (ageVal >= 1) {
      if (ageVal < 19 && ageVal.length > 1) {
        notice = <p className='alert'><strong>Oops! You&rsquo;re too young to purchase health care on your own.</strong><br /> Your parent or guardian can sign you up for a Child Health Plus plan<br /> or put you on their own insurance.</p>;
      }

      if (ageVal >= 65) {
        if (!this.props.quiz.location.loc.Medicare) {
          notice = <p className='alert'>Unfortunately, we don&rsquo;t offer Medicare Advantage plans in your area.<br /> We invite you to use the <a href='https://www.medicare.gov/find-a-plan/questions/home.aspx' target='_blank' rel='noopener noreferrer'>government&rsquo;s Plan Finder</a>.</p>;
          isEnabled = false;
        }
      }

      if (ageVal >= 122) {
        notice = <p className='info'>The oldest person ever whose age has been verified<br /> was <strong>Jeanne Calment</strong> of France, who lived to be 122.</p>;
        isEnabled = false;
      }
    }

    return (
      <section className={'p30 animate ' + this.state.animate}>
        <div className='wrap text-center'>
          <h3>What’s your age?</h3>
          <p className='form'>
            <input
              autoFocus
              id='age'
              type='number'
              name='Age'
              ref={(input) => { this.age = input; }}
              maxLength='3'
              value={quiz.fieldValues.Age}
              onKeyUp={(e) => (e.which === 13 && isEnabled && this._nextStep())}
              onChange={(e) => this._handleAgeChange(e.target.value)}
            />
            {this.props.stepMethods.isNextStep() &&
              <button
                className={'btn next ' + isEnabled}
                disabled={!isEnabled}
                onClick={this._nextStep}
              >Next</button>
            }
          </p>
          <button className='btn back' onClick={this._prevStep}>Previous</button>
          <div className={'message' + (notice ? ' show' : '')}>
            {notice}
          </div>
        </div>
      </section>
    );
  }
}

Age.propTypes = { // validate props expected
  'quiz': object.isRequired,
  'reducer': func.isRequired,
  'stepMethods': object.isRequired
};

export default Age;



// WEBPACK FOOTER //
// ./src/components/Questions/Age.jsx